
export interface IFriendPreferences {
  feedSnoozed: boolean;
  feedFavorite: boolean;
}
export interface IAvatar {
  fileName: string;
  url: string;
}

export interface IUser {
  avatar: IAvatar | null;
  email: string;
  fullName: string;
  id: number;
  userName: string;
  isFriend?: boolean;
  status?: IFriendStatus;
  visibility?: string;
}

export interface IFriend extends IUser {
  date?: Date;
  preferences?: IFriendPreferences
  shareFrom?: IFriendStatus | null
  shareTo?: IFriendStatus | null;
  selected?: boolean;
}

export interface IShareFriend {
  avatar: IAvatar | null;
  date: Date;
  email: string;
  fullName: string;
  id: number;
  preferences: IFriendPreferences
  shareFrom: IFriendStatus;
  shareTo: IFriendStatus;
  userName: string;
}

export interface IContact {
  actorId: number;
  avatar: IAvatar | null;
  canInvite: boolean;
  createdAt: Date;
  email: string | null;
  fullName: string;
  id: string;
  invites: string[];
  phone: string;
  updatedAt: Date;
  userId: number;
}

export interface IRequest {
  avatar: IAvatar | null;
  createdAt: Date;
  email: string;
  fullName: string;
  id: number;
  userName: string;
}

export interface IFriendsResponse {
  data: IFriend[];
  total: number;
}

export interface IRequestsResponse {
  data: IRequest[];
  total: number;
}

export interface IContactResponse {
  data: IContact[];
  total: number;
}


export enum IFriendStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Suspended = 'suspended',
  Blocked = 'blocked',
  Deleted = 'deleted',
}
export enum FriendEvent {
  Removed = 'removed',
  ShareTo = 'shareTo',
  StopSharingFrom= 'stopSharingFrom',
}

export enum ContactEvent {
  Removed = 'removed',
  Invite = 'invite',
  Update = 'update',
}
